import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { SmoothScroll } from '@/components/site/SmoothScroll';
import { LoaderCurtain } from '@/components/site/LoaderCurtain';
import { Header } from '@/components/site/Header';
import { Hero } from '@/components/site/Hero';
import { TrustBadges } from '@/components/site/TrustBadges';
import { Services } from '@/components/site/Services';
import { EditorialMarquee } from '@/components/site/EditorialMarquee';
import { Manifesto } from '@/components/site/Manifesto';
import { Coverage } from '@/components/site/Coverage';
import { Pricing } from '@/components/site/Pricing';
import { Testimonials } from '@/components/site/Testimonials';
import { FaqSection } from '@/components/site/FaqSection';
import { Footer } from '@/components/site/Footer';
import { FloatingCall } from '@/components/site/FloatingCall';

const Home = () => {
	return (
		<div className="App">
			<LoaderCurtain />
			<Header />
			<main>
				<Hero />
				<TrustBadges />
				<Services />
				<EditorialMarquee variant="red" />
				<Manifesto />
				<Coverage />
				<Pricing />
				<Testimonials />
				<EditorialMarquee variant="light" />
				<FaqSection />
			</main>
			<Footer />
			<FloatingCall />
		</div>
	);
};

function App() {
	return (
		<SmoothScroll>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="*" element={<Home />} />
				</Routes>
			</BrowserRouter>
		</SmoothScroll>
	);
}

export default App;
